import React, { useState, useEffect } from 'react';
import {
  Container, Typography, Table, TableHead, TableBody, TableRow, TableCell,
  CircularProgress, Alert, TableContainer, Paper, Grid, Card, CardContent, useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import api from '../../services/api';
import { useTranslation } from 'react-i18next';
import FloatingAddInventoryButton from "../common/FloatingAddInventoryButton";  

const CheckInventory = () => {
  const { t } = useTranslation();
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    api.inventory.list()
      .then((res) => {
        if (res.data.success) setInventory(res.data.data);
        else setError(t("update_inventory_failed"));
      })
      .catch((err) => {
        setError(err.response?.data?.error || t("update_inventory_failed"));
      })
      .finally(() => setLoading(false));
  }, [t]);

  if (loading) {
    return (
      <Container sx={{ mt: 4 }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
      <Container sx={{ mt: 4, px: { xs: 1, sm: 3 } }}>
        <Typography variant="h5" gutterBottom>{t("check_inventory_page_title")}</Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <FloatingAddInventoryButton />


        {/* MOBILE/SMALL SCREEN - CARDS GRID */}
        {isMobile ? (
          <Grid container spacing={2}>
            {inventory.length === 0 ? (
              <Grid item xs={12}>
                <Alert severity="info">{t("no_inventory")}</Alert>
              </Grid>
            ) : (
              inventory.map((item) => (
                <Grid item xs={12} key={item.id}>
                  <Card variant="outlined" sx={{ borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        {item.product_name}
                      </Typography>
                      <Typography variant="body2">
                        {t("quantity")}: <strong>{item.purchased_quantity}</strong>
                      </Typography>
                      <Typography variant="body2">
                        {t("expiration_date")}: <strong>{item.expiration_date || "-"}</strong>
                      </Typography>
                      <Typography variant="body2">
                        {t("notification_days")}: <strong>{item.notification_days || 2}</strong>
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        ) : (
          // DESKTOP - TABLE
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{t("product_name")}</TableCell>
                  <TableCell>{t("quantity")}</TableCell>
                  <TableCell>{t("expiration_date")}</TableCell>
                  <TableCell>{t("notification_days")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inventory.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      {t("no_inventory")}
                    </TableCell>
                  </TableRow>
                ) : (
                  inventory.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.product_name}</TableCell>
                      <TableCell>{item.purchased_quantity}</TableCell>
                      <TableCell>{item.expiration_date || "-"}</TableCell>
                      <TableCell>{item.notification_days || 2}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
            
  );
};

export default CheckInventory;
